import { ApolloProvider } from "@apollo/client";
import "@coreui/coreui-pro/dist/css/coreui.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "react-phone-number-input/style.css";
import { Provider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./App";
import "./App.css";
import store from "./store";
import "./styles/main.sass";
import client from "./utils/api";

const router = createBrowserRouter([
    {
        path: "*",
        element: <App />,
    },
]);

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ApolloProvider client={client}>
                <RouterProvider router={router} />
            </ApolloProvider>
        </Provider>
    </React.StrictMode>,
);
